import React, { useContext } from 'react';
import { compact } from 'lodash';

import Chapter from '../../Chapter';
import ChapterPlayerContext from '../../ChapterPlayer.context';
import { AssetType } from '../../../../utils/storage';

import ProductIntro, {
    Props as ProductIntroProps,
    calculateDuration,
    calculateExitDuration,
} from './screens/ProductIntro';
import { MediaType } from './shared';

import './styles/fonts.scss';


type ProductIntroData = ProductIntroProps & {
    primaryMedia?: MediaType,
    secondaryMedia?: MediaType,
    headMedia?: MediaType,
};

type ProductIntroViewProps = {
    data: ProductIntroData,
    languages: string[],
};

function ProductIntroView({ data, languages }: ProductIntroViewProps) {
    const {
        width,
        height,
    } = useContext(ChapterPlayerContext);

    const resolvedLanguages = data.languages?.length
        ? data.languages
        : (languages?.length ? languages : ['EN']);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                ['--rise-font-vertical-correction' as string]: '1',
            }}
        >
            <ProductIntro
                {...data}
                width={width}
                height={height}
                languages={resolvedLanguages}
            />
        </div>
    );
}

export default class ProductIntroChapter extends Chapter<ProductIntroData> {
    component = () => (
        <ProductIntroView
            data={this.data}
            languages={this.languages}
        />
    )

    fonts = [
        'NTSuperExtended',
        'HelveticaNowDisplay',
    ]

    calculateDuration() {
        const data = this.getChapterData();

        return (calculateDuration(data) - calculateExitDuration(data)) / 1000;
    }

    getAssetsToCache(): AssetType[] {
        const {
            primaryMedia,
            secondaryMedia,
            headMedia,
        } = this.data;

        return compact([primaryMedia, secondaryMedia, headMedia]).filter(media => media.url);
    }

    private getChapterData(): ProductIntroProps {
        const languages = this.data.languages?.length
            ? this.data.languages
            : (this.languages?.length ? this.languages : ['EN']);

        return {
            ...this.data,
            languages,
        };
    }
}
